import { makeStyles } from "@material-ui/core/styles";
import { useRecoilValue } from "recoil";
import { selectedWeatherList, weatherTimeWithID, WX_SETTINGS } from "../../store/WeatherContentsState";
import { mapTimePanelVisibleState } from "../../store/MapTimePanelVisibleState";
import { individualAltitudeLabelWithID, rangeAltitudeLabel } from "../../store/MapAltitudeState";

const useStyles = makeStyles((theme) => ({
  basetimeWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-end'
  },
  basetimeContainer: {
    listStyle: 'none',
    width: 'auto',
    padding: '5px',
    background: '#a9a9a9',
    color: '#fff8dc',
    pointerEvents: 'auto',
    maxHeight: '208px',
    overflowY: 'auto',
  },
  contents: {
    margin: 0,
    fontSize: '0.8em',
    display: 'flex',
    flexWrap: 'nowrap'
  },
  contentsTitle: {
    width: '100px',
    height: '25px',
    lineHeight: '25px',
    textAlign: 'left'
  },
  time: {
    marginLeft: '10px',
    lineHeight: "25px",
    textAlign: 'left',
    flexGrow: 1,
    whiteSpace: 'nowrap'
  },
  timeChild: {
    height: '25px',
    marginBottom: '-10px',
  },
  timeLastChild: {
    height: '25px',
  },
  fl: {
    marginLeft: '5px',
    height: '25px',
    lineHeight: '25px',
    textAlign: 'center',
    width: '100px',
    whiteSpace: 'nowrap'
  },
  WX_ID_UKMET: {
    backgroundColor: 'rgba(0,0,128)'
  },
  WX_ID_ASCSCALE: {
    backgroundColor: 'rgba(83,126,153)'
  },
  WX_ID_ACOS: {
    backgroundColor: 'rgba(0,100,0)'
  },
  multi: {
    backgroundColor: 'rgba(200,200,238,0.7)',
    color: "#022466"
  }
}));

function ContentsInfo() {
  const classes = useStyles();
  const selectedWxList = useRecoilValue(selectedWeatherList);
  const mapTimePanelVisible = useRecoilValue(mapTimePanelVisibleState);

  const flSize = selectedWxList.reduce((size, id) => {
    WX_SETTINGS[id].altitude !== false && size++;
    return size;
  }, 0);

  return (
    <div className={classes.basetimeWrapper}>
      <ul className={classes.basetimeContainer} hidden={selectedWxList.length === 0 || !mapTimePanelVisible}>
        {selectedWxList.map(wxId => {
          return (
            <li key={wxId}>
              <dl className={classes.contents}>
                <TimeRenderer id={wxId}/>
                <FLRenderer id={wxId} flSize={flSize}/>
              </dl>
            </li>
          );
        })}
      </ul>
    </div>
  )
}

function TimeRenderer({id}) {
  const time = useRecoilValue(weatherTimeWithID(id));
  const classes = useStyles();
  let children = [];
  if (time.validTime) {
    children = children.concat(time.validTime);
  }
  if (time.issueTime) {
    children = children.concat(time.issueTime);
  }
  if (time.baseTime) {
    children = children.concat(time.baseTime);
  }
  return (
    <>
      <dt className={classes.contentsTitle}>{time.label}</dt>
      <dd className={classes.time}>
        {children.map((child, idx) => {
          const style = idx === children.length - 1 ? classes.timeLastChild : classes.timeChild;
          return <div key={time.id + idx} className={style}>{child}</div>
        })}
      </dd>
    </>
  )
}

function FLRenderer({id, flSize}) {
  const type = WX_SETTINGS[id].altitude;
  return (
    <>
      {type === 'range' && <RangeFLRender id={id}/>}
      {type === 'individual' && <IndividualFLRender id={id}/>}
      {type === false && <EmptyFLRender contentsInfo={id} flSize={flSize}/>}
    </>
  )
}

function RangeFLRender({id}) {
  const fl = useRecoilValue(rangeAltitudeLabel);
  const classes = useStyles();
  return <dd key={id} className={`${classes.fl} ${classes.multi}`}>{fl}</dd>
}

function IndividualFLRender({id}){
  const fl = useRecoilValue(individualAltitudeLabelWithID(id));
  const classes = useStyles();
  return <dd key={id} className={`${classes.fl} ${classes[id]} `}>{fl}</dd>
}

function EmptyFLRender({id, flSize}) {
  const classes = useStyles();
  const spacerVisible = flSize !== 0
  return (
    <>
      {spacerVisible && <dd key={id} className={classes.fl}/>}
    </>
  );
}
export default ContentsInfo;